export const FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_CAPTURE =
  'CAPTURE';
export const FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_SELECT_FILE =
  'SELECT_FILE';

export const VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME =
  'verification-upload-documents-select-driver-licence-switch-field';

export const VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME =
  'verification-upload-documents-driver-licence-front-field';
export const VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME =
  'verification-upload-documents-driver-licence-back-field';

export const VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME =
  'verification-upload-documents-passport-field';

export const VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_NAME =
  'verification-upload-documents-selfie-field';

export const VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD = {
  label: 'label_upload_documents_driver_licence_front',
  name: VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
  type: 'file',
  docType: 'DL',
  idType: 'DL',
  isRequired: true,
  isReadOnly: false,
  msgSizeLimit: 'form_document_upload_invalid_1',
  msgTypeAccept: 'form_document_upload_invalid_2',
  msgRequired: 'form_document_upload_invalid_3',
  ref: 'refDriverLicenceFront',
};
export const VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD = {
  label: 'label_upload_documents_driver_licence_back',
  name: VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
  type: 'file',
  docType: 'DL',
  idType: 'DL',
  isRequired: true,
  isReadOnly: false,
  msgSizeLimit: 'form_document_upload_invalid_1',
  msgTypeAccept: 'form_document_upload_invalid_2',
  msgRequired: 'form_document_upload_invalid_3',
  ref: 'refDriverLicenceBack',
};

export const VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD = {
  label: 'label_upload_documents_passport',
  name: VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
  type: 'file',
  docType: 'P',
  idType: 'P',
  isRequired: true,
  isReadOnly: false,
  msgSizeLimit: 'form_document_upload_invalid_1',
  msgTypeAccept: 'form_document_upload_invalid_2',
  msgRequired: 'form_document_upload_invalid_3',
  ref: 'refPassport',
};

export const VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_FIELD = {
  label: 'label_upload_documents_selfie',
  name: VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_NAME,
  type: 'file',
  docType: 'SELFIE',
  idType: 'SELFIE',
  isRequired: true,
  isReadOnly: false,
  msgSizeLimit: 'form_document_upload_invalid_1',
  msgTypeAccept: 'form_document_upload_invalid_2',
  msgRequired: 'form_document_upload_invalid_3',
  ref: 'refSelfie',
};

export const RESET_VERIFICATION_UPLOAD_DOCUMENTS = {
  [VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME]: true,
  [VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME]: '',
  [VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME]: '',
  [VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME]: '',
  [VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_NAME]: '',
};
